var map = {
	"./slider-black-right.svg": 80893,
	"./slider-blackWithRoundM-right.svg": 95540,
	"./slider-red-right.svg": 27338,
	"./slider-redWithRound-right.svg": 18680,
	"./slider-redWithRoundM-right.svg": 80001,
	"./slider-whiteWithRoundBlackM-right.svg": 8150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21913;